var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mb-15",attrs:{"light":""},on:{"click":function($event){return _vm.goTo(_vm.post.buttonLink)}}},[_c('v-img',{attrs:{"src":_vm.post.imageUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }